<template>
  <div>
    <!-- tab开始 -->
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane
        :label="'全部 ' + '(' + (pageConfig.total || 0) + ')'"
        name="all"
      ></el-tab-pane>
      <el-tab-pane
        :label="'待检测 ' + '(' + (allKinds.toBeTestedCount || 0) + ')'"
        name="10"
      ></el-tab-pane>
      <el-tab-pane
        :label="'检测中 ' + '(' + (allKinds.detectingCount || 0) + ')'"
        name="20"
      ></el-tab-pane>
      <el-tab-pane
        :label="'已检测 ' + '(' + (allKinds.checkedCount || 0) + ')'"
        name="30"
      ></el-tab-pane>
      <el-tab-pane
        :label="'作废 ' + '(' + (allKinds.cancelCount || 0) + ')'"
        name="99"
      ></el-tab-pane>
    </el-tabs>
    <!-- tab结束 -->
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :filters="filters"
      :buttonList="buttonList"
      @resetBtn="resetBtn"
      @btnCallFunction="callFunction"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:tdate>
        <el-select
          class="dateSelect"
          v-model="filters.dateType"
          placeholder="请选择"
        >
          <el-option
            v-for="item in DateTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
       <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
    </TwTable>
    <LogDialog
      :logPageConfig="logPageConfig"
      :showLog="showLog"
      :requestData="{
        businessType: 41,
        businessCode: currentRow.qcCheckNo,
      }"
      :requestApi="'/WareHouse/BusinessLogServices'"
      :requestMethod="'get'"
      v-if="showLog"
      @showDialog="showDialog"
    >
    </LogDialog>

    <!-- 完结弹窗 -->
    <completeDalog
      :checkResultList="checkResultList"
      :completeDalogType="completeDalogType"
      :handleResultList="handleResultList"
      ref="completeDalogRef"
      @searchTable="initTable"
    ></completeDalog>
  </div>
</template>
      
<script>
import {
  GetQCCheckInfoTaskListAsync,
  AddServicesAsyncOut,
  EditQCCheckInfoStatus,
  GetQCCheckInfoBasis,
  QCCheckInfoAsyncOut,
} from "@/api/QCCheck/index.js";
import LogDialog from "../../components/TwTable/components/logDialog";
import { getCustomerList } from "@/api/common/common.js";
import TwTable from "../../components/TwTable/TwTable";
import hoverCopy from "../../components/hoverCopy.vue";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { arrToJoin, toSelectOptions, getSearchDataIndex } from "util/util";
import completeDalog from "./components/completeDalog.vue";
import { getOperatorInfo } from "@/api/api.js";
export default {
  components: {
    TwTable,
    hoverCopy,
    LogDialog,
    completeDalog,
  },
  mixins: [TwTable_mixins],
  data() {
    return {
      userList: [],
      checkResultList: [],
      handleResultList: [],
      completeDalogType: "",
      DateTypeOptions: [
        {
          value: "a.CreateTime",
          label: "创建时间",
        },
      ],
      filters: {
        dateType: "a.CreateTime",
      },
      allKinds: {},
      activeName: "all",
      tableConfig: {
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showResetButton: true,
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          // 操作栏配置
          align: "center",
          options: [
            {
              name: "日志",
              size: "small",
              type: "text",
              event: "getbusinessLoglist", // 操作的事件名
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "qcCheckNo",
            label: "检测单号",
            minWidth: "160",
          },
          {
            prop: "customName",
            label: "客户",
          },
          {
            prop: "sourceNo",
            label: "入库单号",
            minWidth: "160",
          },
          {
            prop: "warehouseName",
            label: "集货仓",
            minWidth: "100",
          },
          {
            prop: "checkStatusText",
            label: "状态",
          },
          {
            prop: "quantity",
            label: "已收货数",
          },
          {
            prop: "checkResultText",
            label: "检测结果",
          },
          {
            prop: "handleResultText",
            label: "处理结果",
          },
          {
            prop: "checkQty",
            label: "质检数量",
          },
          {
            prop: "badQty",
            label: "不良数量",
          },
          {
            prop: "badReason",
            label: "不良原因",
          },
          {
            prop: "updateUser",
            label: "操作人",
          },
          {
            prop: "updateTimeText",
            label: "操作时间",
            minWidth: "140",
          },
          {
            prop: "createTimeText",
            label: "创建时间",
            minWidth: "140",
          },
        ],
      },
      searchData: {
        // 搜索列配置
        search: [
          {
            type: "input",
            key: "key",
            placeholder: "质检单号/收货单号/参考单号",
            clearable: true,
          },
          {
            type: "select",
            key: "warehouseIds",
            label: "集货仓",
            multiple: true,
            clearable: true,
            options: [],
          },

          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            hideLabel: true,
          },
        ],
        // 高级搜索配置
        moreSearch: [
          {
            type: "select",
            key: "orgIds",
            label: "客户",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "checkStatus",
            label: "状态",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "checkResult",
            label: "检测结果",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "handleResult",
            label: "处理结果",
            multiple: true,
            clearable: true,
            options: [],
          },
          {
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
      //-------------
    };
  },
  methods: {
    // 查询日志
    getbusinessLoglist(row) {
      this.currentRow = row;
      this.showLog = true;
    },
    handleClick() {
      this.$set(
        this.filters,
        "checkStatus",
        this.activeName == "all" ? [] : [this.activeName]
      );
      this.initTable();
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    // 查询列表
    initTable() {
      const {
        warehouseIds,
        orgIds,
        checkResult,
        checkStatus,
        handleResult,
        realName,
        tdate,
      } = this.filters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize || 50,
        ...this.filters,
        warehouseIds: arrToJoin(warehouseIds),
        orgIds: arrToJoin(orgIds),
        checkResult: arrToJoin(checkResult),
        checkStatus: arrToJoin(checkStatus),
        handleResult: arrToJoin(handleResult),
        realName: arrToJoin(realName),
      };
      if (tdate) {
        para.startDate = tdate[0];
        para.endDate = tdate[1];
      }
      this.getTableData(GetQCCheckInfoTaskListAsync, para).then((res) => {
        if (
          res.success &&
          res.response.pageData &&
          res.response.pageData.length
        ) {
          let { toBeTestedCount, detectingCount, checkedCount, cancelCount } =
            res.response.pageData[0];
          this.allKinds = {
            toBeTestedCount,
            detectingCount,
            checkedCount,
            cancelCount,
          };
        } else {
          this.allKinds = {};
        }
      });
    },
    // 开始质检
    startQuality() {
      this.validSelectRows([10], "checkStatus", "只有待检测可以开始质检").then(
        (rowData) => {
          this.$confirm("确认开始质检吗？", "提示", {})
            .then(() => {
              this.$set(
                this.buttonList[this.getButtonIndex("startQuality")],
                "loading",
                true
              );
              let para = {
                qcCheckInfoID: rowData.qcCheckInfoID,
                checkStatus: 20,
              };
              EditQCCheckInfoStatus(para).then((res) => {
                this.$set(
                  this.buttonList[this.getButtonIndex("startQuality")],
                  "loading",
                  false
                );
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg || "操作成功",
                    type: "success",
                  });
                  this.initTable();
                } else {
                  this.$message({
                    message: res.data.msg || "操作失败",
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      );
    },
    // 完结
    complete(rowData) {
      this.validSelectRows([20], "checkStatus", "只有检测中可以开始完结").then(
        (rowData) => {
          this.completeDalogType = "complete";
          this.$nextTick(() => {
            this.$refs.completeDalogRef.showDalog(rowData);
          });
        }
      );
    },
    getButtonIndex(fnName) {
      let fnIndex = 0;
      this.buttonList.forEach((item, index) => {
        if (item.func == fnName) {
          fnIndex = index;
          return;
        }
      });
      return fnIndex;
    },
    // 作废
    voidFn() {
      this.validSelectRows([10], "checkStatus", "只有待检测可以作废").then(
        (rowData) => {
          this.$confirm("确认作废吗？", "提示", {})
            .then(() => {
              this.$set(
                this.buttonList[this.getButtonIndex("voidFn")],
                "loading",
                true
              );
              let para = {
                qcCheckInfoID: rowData.qcCheckInfoID,
                checkStatus: 99,
              };
              EditQCCheckInfoStatus(para).then((res) => {
                this.$set(
                  this.buttonList[this.getButtonIndex("voidFn")],
                  "loading",
                  false
                );
                if (res.data.success) {
                  this.$message({
                    message: res.data.msg || "操作成功",
                    type: "success",
                  });
                  this.initTable();
                } else {
                  this.$message({
                    message: res.data.msg || "操作失败",
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      );
    },
    // 导出
    handleExport() {
      let row = this.selectRows.rows;
      let qcCheckInfoIDs;
      if (row && row.length) {
        qcCheckInfoIDs = row.map((item) => item.qcCheckInfoID).join(",");
      }
      let params = {
        ...this.searchParams,
        qcCheckInfoIDs,
        page: 1,
        pageSize: 60001,
      };
      this.exportFile(QCCheckInfoAsyncOut, params);
    },

    // 单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },

    // 获取搜索栏下拉框数据
    initDropList() {
      // 设置仓库下拉
      let user = JSON.parse(window.localStorage.user);
      this.setSearchOptions(
        "search",
        "warehouseIds",
        toSelectOptions(user.warehouseList, "warehouseId", "warehouseName")
      );

      // 设置客户下拉
      getCustomerList({}).then((res) => {
        this.setSearchOptions(
          "search",
          "orgIds",
          toSelectOptions(res.data.response, "id", "customName")
        );
      });

      // 设置
      GetQCCheckInfoBasis({}).then((res) => {
        if (res.data && res.data.success) {
          // 检测结果
          this.setSearchOptions(
            "moreSearch",
            "checkResult",
            toSelectOptions(res.data.response.checkResultList, "value", "text")
          );
          this.checkResultList = toSelectOptions(
            res.data.response.checkResultList,
            "value",
            "text"
          );
          // 处理结果
          this.setSearchOptions(
            "moreSearch",
            "handleResult",
            toSelectOptions(res.data.response.handleResultList, "value", "text")
          );
          this.handleResultList = toSelectOptions(
            res.data.response.handleResultList,
            "value",
            "text"
          );
          //状态
          this.setSearchOptions(
            "search",
            "checkStatus",
            toSelectOptions(res.data.response.checkStatusList, "value", "text")
          );
        }
      });
    },
    resetBtn() {
      this.filters = { dateType: "a.CreateTime" };
    },
  },

  mounted() {
    // 获取按钮配置
    this.getMixinsButtonList();
    // 获取搜索栏下拉框数据
    this.initDropList();

    getOperatorInfo().then((res) => {
      this.userList = res.data.response;
    });
  },
};
</script>
    
<style scoped>
.dateSelect {
  width: 130px;
  margin-right: 12px;
}
</style>